import React from 'react';
import PropTypes from 'prop-types';

import {withI18n} from 'spa/Components/Context';

import PressFeaturedEN from './PressFeaturedEN';
import PressFeaturedFR from './PressFeaturedFR';

import './PressFeatured.less';

@withI18n
class PressFeatured extends React.Component {
  static propTypes = {
    isAmpPage: PropTypes.bool,
    smallLogos: PropTypes.bool,
  };

  render() {
    const {i18n} = this.context;
    const {region} = i18n;
    const {isAmpPage, smallLogos} = this.props;

    switch (region) {
    case 'FR':
      return (
        <PressFeaturedFR
          isAmpPage={isAmpPage}
          smallLogos={smallLogos} />
      );
    default:
      return (
        <PressFeaturedEN isAmpPage={isAmpPage} />
      );
    }
  }
}

export default PressFeatured;



// WEBPACK FOOTER //
// ./spa/Pages/Home/PressFeatured.jsx